import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React, { Component } from 'react';
import { getProject } from '../../../common/services/project';
import { IProduct } from '../typings';

interface IProps {
  tableData: IProduct;
}
export class ProductRow extends Component<IProps> {
  public render() {
    const { tableData } = this.props;
    const { name, categoryTranslated, typeTranslated, season } = tableData;
    const href = `#${getProject().url}/products/${tableData.id}`;

    return (
      // @ts-ignore href
      <TableRow hover href={href} component="a">
        <TableCell>{name}</TableCell>
        <TableCell>{categoryTranslated}</TableCell>
        <TableCell>{typeTranslated}</TableCell>
        <TableCell>{season ? season.shortName : ''}</TableCell>
      </TableRow>
    );
  }
}
